import { render, staticRenderFns } from "./FormSecundarioExamen.vue?vue&type=template&id=3bd48406&"
import script from "./FormSecundarioExamen.vue?vue&type=script&lang=js&"
export * from "./FormSecundarioExamen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports